import React from "react"
import { ClassProps } from "../../utility/common/props"
import ContextMenu from "../ContextMenu/ContextMenu"
import styles from "./SettingsContextMenu.module.scss"
import cn from "classnames"
import { Placement } from "react-bootstrap/esm/Overlay"
import { ContextMenuProps } from "../ContextMenu/ContextMenu"
export interface SettingsContextMenuProps extends ClassProps, ContextMenuProps {
    placement?: Placement
}

const SettingsContextMenu: React.FC<SettingsContextMenuProps> = props => {
    const { children, className, placement = "bottom" } = props

    return (
        <ContextMenu
            {...props}
            placement={placement}
            className={styles.settingsContextMenu}
            containerClassName={cn(styles.settingsContextMenu__container, className)}
            popperConfig={{
                modifiers: [
                    {
                        name: "flip",
                        enabled: true
                    }
                ]
            }}
        >
            {children}
        </ContextMenu>
    )
}

export default SettingsContextMenu
